import { BrightcoveVideo } from "@components/Blocks/BrightcoveVideo/BrightcoveVideo";

export type PodcastDialogProps = {
  videoDialog: {
    visible: boolean;
    source: string;
  };
  handleOnClickCloseDialog: () => void;
};

export default function VideoDialog({
  videoDialog,
  handleOnClickCloseDialog,
}: PodcastDialogProps) {
  const { visible, source } = videoDialog;
  return (
    <>
      {visible && (
        <div className="fixed bottom-4 right-0 md:right-4 p-2 z-50 w-full md:w-[520px]">
          <div className="relative">
            <BrightcoveVideo videoId={source} smallWidget={true} />
          </div>
          <div className="z-10 absolute top-0 right-0 flex items-center justify-center w-8 h-8 p-1 rounded-full bg-black-500">
            <button
              onClick={handleOnClickCloseDialog}
              id="close"
              className="text-white-100 text-sm outline-none focus:outline-none"
            >
              X
            </button>
          </div>
        </div>
      )}
    </>
  );
}
